import { CoreBox, CoreTypography } from '@youscience/core';

import useUserPreferencesStore from '@store/UserPreferencesStore';

import { EDUCATION_OPPORTUNITIES_CARDS } from '@constants/nonLearnerHomePage';
import { CARD_IDS } from '@constants/baseHomePage';

import { Container } from '@components/Layout/components/Container';

import EducationOpportunityCard from './components/EducationOpportunityCard';

import { sxStyles, StyledSectionInner } from './EducationOpportunities.styles';

export const EducationOpportunities = () => {
  const { schoolFavorites } = useUserPreferencesStore((state) => state);
  const { cipCodes: favoriteMajorsCipCodes } = useUserPreferencesStore((state) => state.majorFavorites);
  const scholarshipFavorites = useUserPreferencesStore((state) => state.scholarshipFavorites);

  const favoriteCount = {
    [CARD_IDS.MAJORS]: favoriteMajorsCipCodes.length || 0,
    [CARD_IDS.SCHOOLS]: schoolFavorites.length || 0,
    [CARD_IDS.SCHOLARSHIPS]: scholarshipFavorites.length || 0,
  };

  return (
    <Container>
      <StyledSectionInner>
        <CoreTypography sx={sxStyles.sectionTitle} variant="h2">
          Explore education opportunities
        </CoreTypography>

        <CoreBox sx={sxStyles.opportunitiesCardsWrap}>
          {EDUCATION_OPPORTUNITIES_CARDS.map((opportunity) => {
            const { id, icon, title, description, favoriteLink, startExploringLink } = opportunity;

            return (
              <EducationOpportunityCard
                key={id}
                icon={icon}
                title={title}
                description={description}
                favoriteCount={favoriteCount[id]}
                favoriteLink={favoriteLink}
                startExploringLink={startExploringLink}
              />
            );
          })}
        </CoreBox>
      </StyledSectionInner>
    </Container>
  );
};
